module.exports = "pegasus/assets/blocks/column-lp7-themelp1.png";